import React from "react";
// ANT DESIGN COMPONENTS
import { Table, Tag, Tooltip } from "antd";
// REDUX
import { useSelector } from "react-redux";
// INTERFACES
import { RootState } from "../../../app/store";
import { BankInterface } from "../../../interfaces/Bank.interface";

export default function TerminalBankFloors({ bank }: { bank: BankInterface }) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const columns = [
		{
			title: "Floor Name",
			dataIndex: "name",
			key: "name",
			render: (text: string) => <b>{text}</b>,
		},
		{
			title: "Floor Index",
			dataIndex: "floor_index",
			key: "floor_index",
		},
		{
			title: "Front Door",
			dataIndex: "front_door",
			key: "front_door",
			render: (open: boolean) => (open ? <Tag color='green'>True</Tag> : <Tag color='red'>False</Tag>),
		},
		{
			title: "Rear Door",
			dataIndex: "rear_door",
			key: "rear_door",
			render: (open: boolean) => (open ? <Tag color='green'>True</Tag> : <Tag color='red'>False</Tag>),
		},
		{
			title: "Updated At",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (date: string) => <Tooltip title={date}>{new Date(date).toLocaleString()}</Tooltip>,
		},
	];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className={`monitoring__card__${theme} generalStyles__width100`} style={{ height: "auto", marginTop: "20px" }}>
			{bank && bank.bank_floors && bank.bank_floors.length > 0 && (
				<Table
					columns={columns}
					dataSource={[...bank.bank_floors].sort((a, b) => b.floor_index - a.floor_index)}
					rowKey='id'
					pagination={false}
					bordered
					size='small'
				/>
			)}
		</div>
	);
}
